export default {
    name: 'sitemapBreadcrumb',
    props: {
        breadCrumb: {
            type: Array,
            default() {
                return [];
            },
        },
        isBanner: {
            type: Boolean,
            default: false,
        },
    },
};
